export const MARKET_TAB_ORDER = 'mkt_track_purchase' // 결제 완료
export const MARKET_TAB_USE_COUPON = 'mkt_track_use_coupon'
